const React = require('react');

const Item = require('../common/ItemV2.jsx');
const LineItemCell = require('../common/LineItemCell.jsx');
const Name = require('../utility/Name.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region META

const TokensMeta = (data) => [
    Token.getWrappedTokenConfig('Artist Name', Token.Artist.Name),
    Token.getWrappedTokenConfig('Title', Token.Inventory.Title),
    Token.getWrappedTokenConfig('Edition Info', Token.Inventory.Edition),
    Token.getWrappedTokenConfig('Created Date', Token.Date),
    Token.getWrappedTokenConfig('Medium', Token.Inventory.Medium),
    Token.getWrappedTokenConfig('Dimensions', Token.Inventory.Dimensions),
    Token.getWrappedTokenConfig('Inventory Number', Token.Inventory.Number),
    Token.getWrappedTokenConfig('SKU', Token.Inventory.SKU),
    Token.getWrappedTokenConfig('Location', Token.Inventory.Location),
    Token.getWrappedTokenConfig('Acquisition Date', Token.Inventory.AcquisitionDate),
    Token.getCurrencyTokenConfig('Retail Price', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Total.Retail, Token.firstLineCurrencyDifferentToggleOption),
    Token.getCurrencyTokenConfig('Consignment Cost', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Total.Consignment, Token.firstLineCurrencyDifferentToggleOption)
];

// #endregion META

// #region CONTAINER

function LineItemContainer(props) {
    const handleBlockExtras = (props, block) => {
        if (!block.type) {
            return;
        }
        switch (block.type.value) {
            case Name.Block.Inventory.Image:
                return { transform: 'c_fit' };
        }
    }
    return <LineItemCell.Container.Component {...props} onBlockExtras={handleBlockExtras} />
}

const TypeConfigLineItemContainer = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "columnCount": "4",
                            "collapseIfEmpty-col1": false,
                            "alignmentHeader-col1": "tl",
                            "alignment-col1": "tl",
                            "minWidth-col1": {
                                "unit": "px",
                                "value": "190"
                            },
                            "width-col1": {
                                "unit": "%",
                                "value": ""
                            },
                            "alignmentHeader-col2": "tl",
                            "alignment-col2": "tl",
                            "width-col2": {
                                "unit": "%",
                                "value": "100"
                            },
                            "alignmentHeader-col3": "tl",
                            "alignment-col3": "tl",
                            "minWidth-col3": {
                                "unit": "px",
                                "value": "95"
                            },
                            "width-col3": {
                                "unit": "%",
                                "value": ""
                            },
                            "alignmentHeader-col4": "tl",
                            "alignment-col4": "tl",
                            "collapseIfEmpty-col4": true,
                            "minWidth-col4": {
                                "unit": "px",
                                "value": "125"
                            },
                            "width-col4": {
                                "unit": "%",
                                "value": ""
                            },
                            "alignmentHeader-col5": "tl",
                            "alignment-col5": "tl",
                            "collapseIfEmpty-col5": true,
                            "width-col5": {
                                "unit": "%",
                                "value": ""
                            },
                            "alignmentHeader-col6": "tl",
                            "alignment-col6": "tl",
                            "width-col6": {
                                "unit": "%",
                                "value": ""
                            },
                            "designHeader-col3": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: 'Retail Price' }),
                            "designHeader-col4": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: 'Consignment Cost' }),
                            "renderHeaderOnlyFirst": true,
                            "spacing": {
                                "unit": "px",
                                "value": "20"
                            }
                        },
                        "Style": {}
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                    "type": {
                        "value": "columns"
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "Block": {
                                        "maxHeight": {
                                            "unit": "px",
                                            "value": "199"
                                        },
                                        "maxWidth": {
                                            "unit": "px",
                                            "value": "163"
                                        }
                                    },
                                    "Style": {
                                        "textAlign": "center"
                                    }
                                },
                                "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Image
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": `${Utilities.wrapTextForEditor({ text: `{${Token.Artist.Name}("before":"","after":"")}`, token: Token.Artist.Name })}<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Inventory.Title, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Edition, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Medium}("before":"","after":"")}`, token: Token.Inventory.Medium })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Dimensions}("before":"","after":"")}`, token: Token.Inventory.Dimensions })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.SKU}("before":"SKU: ","after":"")}`, token: Token.Inventory.SKU })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Number}("before":"Inventory #: ","after":"")}`, token: Token.Inventory.Number })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Location}("before":"","after":"")}`, token: Token.Inventory.Location })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.AcquisitionDate}("before":"Acquisition Date: ","after":"")}`, token: Token.Inventory.AcquisitionDate })}`
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-1-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Total.Retail}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","formatFirst":"")}`, token: Token.Total.Retail })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-2-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Total.Consignment}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","formatFirst":"")}`, token: Token.Total.Consignment })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-3-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ]
                    ]
                }
            ]
        },
        "Type": Name.Content.ConsignmentLineItem
    })
}

// #endregion CONTAINER

module.exports = {
    Container: {
        Blocks: LineItemCell.Container.Blocks,
        Component: LineItemContainer,
        TypeConfig: TypeConfigLineItemContainer
    },
    Image: Item.Image,
    Meta: {
        ...Item.Meta,
        Tokens: TokensMeta
    }
}